export default {
  list: { lazy: () => import('./FinanceProductTerms'), component: 'FinanceProductTermList' },
  create: { lazy: () => import('./FinanceProductTerms'), component: 'FinanceProductTermCreate' },
  edit: { lazy: () => import('./FinanceProductTerms'), component: 'FinanceProductTermEdit' },
}
